module.exports = __webpack_public_path__ + "static/media/indonesia.64c759ff.svg";